module.exports = __webpack_public_path__ + "static/8-7c30aa78a3af2cd302d1c2457fe6b66e.svg";